var styles = {
  "Wrapper": "Online-Store-UI-ResizeableCombo__Wrapper_jwgr7",
  "CloneTarget": "Online-Store-UI-ResizeableCombo__CloneTarget_1i9zc",
  "ResizeableCombo": "Online-Store-UI-ResizeableCombo_a3g82",
  "animationBeforeExpanding": "Online-Store-UI-ResizeableCombo--animationBeforeExpanding_1ys0w",
  "animationBeforeShrinking": "Online-Store-UI-ResizeableCombo--animationBeforeShrinking_iwlu3",
  "animationExpanding": "Online-Store-UI-ResizeableCombo--animationExpanding_xk3nx",
  "animationShrinking": "Online-Store-UI-ResizeableCombo--animationShrinking_bz0y9",
  "sizeExpanded": "Online-Store-UI-ResizeableCombo--sizeExpanded_uve0z",
  "sizeFullscreen": "Online-Store-UI-ResizeableCombo--sizeFullscreen_194h9",
  "FooterChildren": "Online-Store-UI-ResizeableCombo__FooterChildren_ck70g",
  "SizeSwitcherWrapper": "Online-Store-UI-ResizeableCombo__SizeSwitcherWrapper_18myk"
};

export { styles as default };
